/**
 * @param {CookieInteractor} cookieInteractor
 * @return {Object}
 */
export default ({ cookieInteractor }) => ({
  /**
   * Initialise cookie consent. Should be called on page load.
   *
   * @param {Function} commit
   */
  init({ commit }) {
    const existingDecision = cookieInteractor.read({ name: 'cookieConsent' })
    let decision = null

    if (existingDecision === '1') {
      decision = true
    } else if (existingDecision === '0') {
      decision = false
    }

    commit('SET_DECISION', { decision })
  },

  /**
   * Sets the user decision on cookie consent.
   *
   * @param {Function} commit
   * @param {Boolean} decision
   */
  setDecision({ commit }, { decision }) {
    cookieInteractor.write({ name: 'cookieConsent', value: decision ? '1' : '0' })
    commit('SET_DECISION', { decision })
  },
})
